/**
 * src/modules/notif-prefs.ts — preferencje kategorii powiadomień (2026-09-01).
 *
 * Zgłoszenie usera: „dostaję non stop powiadomienia o wystawionych fakturach;
 * powinna być opcja np. tylko o błędach". Backend nadaje każdemu eventowi SSE
 * `category` (core/notifications.py), a klient wycisza kategorie odznaczone
 * w panelu dzwonka. Zapis w localStorage = per przeglądarka/użytkownik
 * (powiadomienia i tak są ulotne, SSE bez persystencji).
 *
 * Kontrakt: brak wpisu = kategoria WŁĄCZONA; wyciszona tylko przy jawnym false.
 */

export const NOTIF_KATEGORIE: Array<[string, string]> = [
  ['invoices', 'Faktury — wystawione'],
  ['invoice_errors', 'Faktury — błędy wystawiania'],
  ['orders', 'Nowe zamówienia'],
  ['customers', 'Nowi klienci'],
  ['sync', 'Synchronizacje'],
  ['tasks', 'Zadania'],
  ['errors', 'Błędy i ostrzeżenia'],
  ['other', 'Pozostałe'],
];

const KLUCZ = 'sb_notif_prefs';

export function getNotifPrefs(): Record<string, boolean> {
  try {
    return JSON.parse(localStorage.getItem(KLUCZ) || '{}') || {};
  } catch (_e) {
    return {};
  }
}

export function isNotifCategoryMuted(cat: string): boolean {
  if (!cat) return false;
  return getNotifPrefs()[cat] === false;
}

export function setNotifCategory(cat: string, wlaczona: boolean): void {
  try {
    var p = getNotifPrefs();
    p[cat] = !!wlaczona;
    localStorage.setItem(KLUCZ, JSON.stringify(p));
  } catch (_e) { /* prywatne okno itp. — preferencje po prostu nie zapisane */ }
}

/** 21.10.2026 (właściciel: „po co takie powiadomienie? Nawet nie mam włączonego tego typu powiadomień” — dzwonek
 *  z „Przeniesiono do grupy »WYDRUKOWANE«”): toasty są komunikatem chwili. Potwierdzenia własnych działań
 *  (success / info) nie trafiają do dzwonka; błędy i ostrzeżenia — tylko przy włączonej kategorii „Błędy i ostrzeżenia”. */
export function toastDoDzwonka(type: any): boolean {
  var t = String(type || 'info').toLowerCase();
  if (t !== 'error' && t !== 'warning') return false;
  return !isNotifCategoryMuted('errors');
}
